angular.module("app").directive("homeStyleColorModalDetail", () => {
  let link = (scope) => {
    scope.data = scope.popupData;

    scope.newmoodboard = (item) => {
      const data = {
        type: 'home',
        item: item
      } 
      scope.$emit("mood_state_item_chart", data);
    };

    scope.closeClickHandler = () => {
      scope.closefunction();
    };

    scope.shareFacebook = (url) => {
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + url);
    };

    scope.shareTwitter = (url) => {
      window.open("https://twitter.com/home?status=" + url);
    };

    scope.sharePinterest = (url) => {
      window.open("https://pinterest.com/pin/create/button/?url=" + url);
    };

    scope.shareInstagram = (url) => {
      window.open("https://instagram.com/?url=" + url);
    };

    scope.shareGooglePlus = (url) => {
      window.open("https://plus.google.com/share?url=" + url);
    };
  };

  return {
    restrict: "E",
    templateUrl: "app/directives/homeStyleOfColorCategory/homeStyleColorModalView.html",
    link: link,
    scope: {
      popupData: "=",
      index: "=",
      onClose: "&",
      closefunction: "=",
    },
  };
});
